import { gql } from '@apollo/client'

export const GET_LEGAL_DOCUMENTS = gql`
  query GetLegalDocuments(
    $after: String
    $before: String
    $first: Int
    $last: Int
    $order: [LegalDocumentSortInput!]
    $where: LegalDocumentFilterInput
  ) {
    legalDocuments(
      after: $after
      before: $before
      first: $first
      last: $last
      order: $order
      where: $where
    ) {
      edges {
        node {
          id
          name
          versionMajor
          versionMinor
          versionPatch
          documentType
          isActive
          deactivatedAt
          createdAt
          createdBy
          lastModifiedAt
          lastModifiedBy
        }
      }
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasPreviousPage
        hasNextPage
      }
    }
  }
`

export const GET_LEGAL_DOCUMENT = gql`
  query GetLegalDocument($id: Long!) {
    legalDocument(id: $id) {
      id
      name
      versionMajor
      versionMinor
      versionPatch
      documentType
      content
      isActive
      deactivatedAt
      originalFileUri
      originalFileName
      createdAt
      createdBy
      lastModifiedAt
      lastModifiedBy
    }
  }
`

export const GET_ACTIVE_LEGAL_DOCUMENT = gql`
  query GetActiveLegalDocument($documentType: LegalDocumentType!) {
    activeLegalDocument(documentType: $documentType) {
      id
      name
      versionMajor
      versionMinor
      versionPatch
      documentType
      content
      isActive
      originalFileUri
      originalFileName
      createdAt
      createdBy
    }
  }
`

export const GET_LEGAL_DOCUMENTS_ALL = gql`
  query GetLegalDocumentsAll(
    $after: String
    $before: String
    $first: Int
    $last: Int
    $order: [LegalDocumentSortInput!]
    $where: LegalDocumentFilterInput
  ) {
    legalDocuments(
      after: $after
      before: $before
      first: $first
      last: $last
      order: $order
      where: $where
    ) {
      edges {
        node {
          id
          name
          versionMajor
          versionMinor
          versionPatch
          documentType
          content
          isActive
          deactivatedAt
          originalFileUri
          originalFileName
          createdAt
          createdBy
          lastModifiedAt
          lastModifiedBy
        }
      }
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasPreviousPage
        hasNextPage
      }
    }
  }
`

export const GET_LEGAL_DOCUMENT_HISTORY = gql`
  query GetLegalDocumentHistory(
    $documentType: LegalDocumentType!
    $after: String
    $before: String
    $first: Int
    $last: Int
  ) {
    legalDocumentHistory(
      documentType: $documentType
      after: $after
      before: $before
      first: $first
      last: $last
    ) {
      edges {
        node {
          id
          name
          versionMajor
          versionMinor
          versionPatch
          documentType
          isActive
          deactivatedAt
          originalFileUri
          originalFileName
          createdAt
          createdBy
        }
      }
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasPreviousPage
        hasNextPage
      }
    }
  }
`

export const GET_DRIVER_UNACCEPTED_LEGAL_DOCUMENTS = gql`
  query GetDriverUnacceptedLegalDocuments {
    driverUnacceptedLegalDocuments {
      majorUnacceptedDocuments {
        id
        name
        documentType
        versionMajor
        versionMinor
        versionPatch
        content
      }
      minorUnacceptedDocuments {
        id
        name
        documentType
        versionMajor
        versionMinor
        versionPatch
        content
      }
      patchUnacceptedDocuments {
        id
        name
        documentType
        versionMajor
        versionMinor
        versionPatch
        content
      }
    }
  }
`

